module.exports = __webpack_public_path__ + "img/business_hero_DT.9d2daee.png";